import { createAuthClient } from "better-auth/client";
import configService from "./configService";
import posthogService from "./posthogService";

type SocialSignInRequest = {
  anonymousId?: string;
  provider: string;
  idToken?: {
    token: string;
  };
};

type SocialSignInResult = {
  data?: unknown;
  error?: {
    message?: string;
  };
};

type AuthClient = {
  signIn: {
    social: (input: SocialSignInRequest) => Promise<SocialSignInResult>;
  };
};

// Static ESM import is required: a bare `require()` call survives the Vite
// build untransformed and throws "require is not defined" in the browser,
// which silently degraded sign-in to a dead stub under the old try/catch.
export const authClient: AuthClient = createAuthClient({
  baseURL: configService.getApiBaseUrl(),
  basePath: "/v2/auth",
  fetchOptions: {
    onRequest(context) {
      for (const [name, value] of Object.entries(posthogService.getRequestHeaders())) {
        context.headers.set(name, value);
      }
    },
  },
}) as unknown as AuthClient;

export default authClient;
